export var getSelectedAccountId = function () {
    var _a;
    return (_a = sessionStorage.getItem('selectedAccountId')) !== null && _a !== void 0 ? _a : '';
};
export var setSelectedAccountId = function (accountId) {
    sessionStorage.setItem('selectedAccountId', accountId);
};
